import { useState } from "react";
import InterviewsFilters from "../../components/filters/InterviewsFilters";
import Loader from "../../components/main/Loader";
import TableComponent from "../../components/main/Table";
import { InterviewAdapterFilterSent } from "../../helpers/adapter/filters/AdapterFilterInterviews";
import { initialParams, IPagination, PaginationHelper } from "../../helpers/PaginationHelper";
import { useGetInterviewsQuery } from "../../store/services/InterviewService";
import { HeaderInterviews } from "../../utils/headerTable/TabHeaderInterviews";
import { useSelector } from "react-redux";
import { selectCurrentUserInfo } from "../../store/feautures/AuthSlice";

export default function InterviewListPage() {

    const { role } = useSelector(selectCurrentUserInfo);
    const [queryParams, setQueryParams] = useState<IPagination>(initialParams);
    const [filterParams, setFilterParams] = useState<any>({});
    let {isSuccess, isLoading, data, isFetching } = useGetInterviewsQuery({...queryParams, ...filterParams});

    const handleActionTable = (data: any) => {
        let paramsPagination: any = PaginationHelper(queryParams, data);
        setQueryParams(paramsPagination);
    }

    const handleSetFilter = (dataFilter: any) => {
        let payload = { ...dataFilter };

        if (role !== 'Consulente') {
            delete payload.IncludiIntervisteNonMie;
        }

        const filterAdapter = InterviewAdapterFilterSent(payload);
        setFilterParams(filterAdapter);
        setQueryParams(initialParams);
    };

    return(
        <>  
            {(isLoading || isFetching) && <Loader />}
            <h2 className="text-xl my-6">Lista interviste</h2>

            <InterviewsFilters methodParent={handleSetFilter} />

            <div className="mt-10">
            {isSuccess && data?.result.length > 0 
                ? <TableComponent columns={HeaderInterviews} data={data?.result} meta={data?.meta} parentMethod={handleActionTable} pageIndex={queryParams?.CurrentPage} pageSizeParent={queryParams?.PageSize} sortDirectionParent={queryParams?.sortDirection} currentSortCol={queryParams?.sortIdCol} /> 
                : <p className="p-6 text-center">NESSUNA INTEVISTA PRESENTE</p>
            }
            </div>

        </>
    )
}